import { injectGlobal } from 'styled-components'
import icomoonWOFF from 'assets/fonts/icomoon.woff'
import icomoonTTF from 'assets/fonts/icomoon.ttf'
import icomoonSVG from 'assets/fonts/icomoon.svg'

export default injectGlobal`
  @font-face {
    font-family: "icomoon";
    src: url('${icomoonWOFF}') format("woff"),
    url('${icomoonTTF}') format("truetype"), 
    url('${icomoonSVG}') format("svg");
    font-weight: normal;
    font-style: normal;
  }
`


// WEBPACK FOOTER //
// ./src/utils/fonts.js